import { useState, useCallback } from 'react';
import { graphQlClient } from '@config/graphqlClient';
import MaterialGraphQL from '@graphql/material.queries';

interface UseDeleteMaterialReturn {
  deleteMaterial: (id: string) => Promise<boolean>;
  loading: boolean;
  error: string | null;
}

export const useDeleteMaterial = (): UseDeleteMaterialReturn => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const deleteMaterial = useCallback(async (id: string): Promise<boolean> => {
    if (!id) return false;

    setLoading(true);
    setError(null);

    try {
      const data: any = await graphQlClient.request(
        MaterialGraphQL.mutations.deleteMaterial,
        { id },
      );

      const success = data?.deleteMaterial?.affected > 0;
      if (!success) {
        setError('Failed to delete material');
        return false;
      }

      return true;
    } catch (err: any) {
      setError(
        err?.response?.errors?.[0]?.message || 'Failed to delete material',
      );
      return false;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    deleteMaterial,
    loading,
    error,
  };
};
